import React, { Component } from 'react';
import Logo from '../img/logo.png'


class Sucess extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }
    render() { 

        const river = localStorage.getItem('river')
        const section = localStorage.getItem('section')
        const habitat = localStorage.getItem('habitat')
        const temperature = localStorage.getItem('temperature')
        const waterTemperature = localStorage.getItem('waterTemperature')
        const weather = localStorage.getItem('weather')
        const lat = localStorage.getItem('lat')
        const lon = localStorage.getItem('lon')
        const algae = localStorage.getItem('algae')
        const dead = localStorage.getItem('dead')
        const fieldNotes = localStorage.getItem('fieldNotes')
        return ( 
            <div className="card">
                <div className="card-heading">
                    <h2>Thank You!</h2>
                    <p>We value your time collecting and reporting your data to us.</p>
                    <p>We received the following information:</p>
                </div>
                <ul>
                    <li> <b>River Sampled:</b> {river} </li>
                    <li> <b>Section sampled:</b> {section}</li>
                    <li> <b>Latitude:</b> {lat}</li>
                    <li> <b>Longitude:</b> {lon}</li>
                    <li> <b>Weather Observation:</b> {weather}</li>
                    <li> <b>Air temperature:</b> {temperature}</li>
                    <li> <b>Water Temperature:</b> {waterTemperature}</li>
                    <li> <b>Habitat Sampled:</b> {habitat}</li>
                    <li> <b>Algae Observation:</b> {algae}</li>
                    <li>  <b>Dead Observed:</b> {dead}</li>
                    <li> <b>Field Notes:</b> {fieldNotes}</li>
                </ul>
                <br/>
<div className="card-content">
    <p>Learn more about 
    <a href="http://www.roaringfork.org/drought/hot-spots-for-trout/"> Hot spots for Trout</a>
"</p>
<p>See Roaring Forks <a href="http://www.roaringfork.org/news/weekly-river-report/">Weekly Reports</a>
</p>
</div>

<img src={Logo} width="100%" alt="Roaring Fork conservancy"/>
</div>

         );
    }
}
 
export default Sucess;



